import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgCommonModule } from '@principle-theorem/ng-shared';
import { ReportBuilderDataSourceInstance } from '@principle-theorem/reporting';
import { QueryFilterDisplayComponent } from '../query-filter-display/query-filter-display.component';

@Component({
  selector: 'pr-data-source-display',
  templateUrl: './data-source-display.component.html',
  styleUrls: ['./data-source-display.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgCommonModule, QueryFilterDisplayComponent],
  host: {
    class: 'inline-block',
  },
})
export class DataSourceDisplayComponent {
  dataSource = input.required<ReportBuilderDataSourceInstance | undefined>();
}
